@if (visible && (dialogProperties$ | async); as dialogProperties) {
  <bd-dialog
    data-id="create-population-dialog"
    [visible]="visible"
    (dismiss)="cancel()"
    [dialogProperties]="dialogProperties"
    *transloco="let t; scope: 'featureSearch'"
  >
    <div data-id="population-description" class="mb-6 flex flex-col gap-2">
      <p
        data-id="population-description-label"
        class="bd-population-dialog-label bd-label-small-gray"
      >
        {{ t('featureSearch.saveAsPopulationModal.contains') }}
      </p>
      @if (populationType === 'dynamic') {
        <p data-id="dynamic-population-count" class="bd-body-regular">
          {{
            t(
              'featureSearch.saveAsPopulationModal.dynamicPopulationDescription',
              {
                number: numberOfFilters,
                pluralSuffix: numberOfFilters === 1 ? '' : 's',
              }
            )
          }}
        </p>
        @if (showWarningMessageForDynamicPopulation) {
          <div data-id="dynamic-population-warning" class="flex gap-2">
            <i class="ui-warning bd-warning-icon"></i>
            <p class="bd-caption bd-population-dialog-label">
              {{
                t(
                  'featureSearch.saveAsPopulationModal.dynamicPopulationWarningMessage'
                )
              }}
            </p>
          </div>
        }
      } @else {
        <p data-id="static-population-count" class="bd-body-regular">
          {{
            t(
              'featureSearch.saveAsPopulationModal.staticPopulationDescription',
              {
                number: numberOfSelectedObjects,
                pluralSuffix: numberOfSelectedObjects === 1 ? '' : 's',
              }
            )
          }}
        </p>
      }
    </div>

    <div class="flex gap-2 flex-col">
      <div class="bd-label-small-gray" data-id="input-label">
        {{ t('featureSearch.saveAsPopulationModal.inputLabel') }}
      </div>
      <p-inputgroup>
        <input
          data-id="population-name-input"
          id="population-name"
          type="text"
          pInputText
          [(ngModel)]="populationName"
          autocomplete="off"
          [placeholder]="
            t('featureSearch.saveAsPopulationModal.inputPlaceholder')
          "
          [disabled]="populationNameInputDisabled"
          (keydown.enter)="save()"
        />
      </p-inputgroup>
    </div>

    <div class="flex gap-x-4 justify-end" footer>
      <p-button
        data-id="cancel-create-population-btn"
        [outlined]="true"
        [label]="t('featureSearch.saveAsPopulationModal.cancelBtn')"
        (onClick)="cancel()"
      ></p-button>
      <div
        class="inline-block"
        [pTooltip]="t('featureSearch.saveAsPopulationModal.saveAsBtnTooltip')"
        tooltipPosition="top"
        [tooltipDisabled]="!!populationName"
      >
        <p-button
          data-id="create-population-btn"
          [label]="t('featureSearch.saveAsPopulationModal.saveAsBtn')"
          [disabled]="!populationName"
          (onClick)="save()"
          [loading]="dataForPopulationLoading"
        ></p-button>
      </div>
    </div>
  </bd-dialog>
}
